module.exports = __webpack_public_path__ + "img/20210730_122443.f68d194f.jpg";